import { useToastStore } from '@/stores/toast'

export default function ToastBar() {
  const { visible, type, message, hide } = useToastStore()
  if (!visible) return null
  const cls = type === 'success'
    ? 'border-green-300 bg-green-50 text-green-700'
    : type === 'error'
      ? 'border-red-300 bg-red-50 text-red-700'
      : 'border-blue-300 bg-blue-50 text-blue-700'
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50">
      <div className={`rounded border px-4 py-2 shadow ${cls} flex items-center gap-3`}>
        <span>{message}</span>
        <button className="text-xs opacity-70 hover:opacity-100" onClick={hide}>关闭</button>
      </div>
    </div>
  )
}